<div class="main-container-syncing" *ngIf="appService.theme$ | async as theme">
    <div class="spinner-container" 
    [style]="{'background': theme === 'light' ? 'var(--p-surface-0)' : 'var(--p-surface-50)'}">
        <p-progress-spinner
        [dt]="progressSpinner"
            [style]="{width: '44px', height: '44px'}" 
            strokeWidth="4"  
            animationDuration="1.0s"
             />
        <button class="cancel-button" (click)="cancelRequest()"
        [style]="{
            'background': theme === 'light' ? 'var(--p-primary-600)' : 'transparent',
            'color' : theme === 'light' ? 'var(--p-surface-0)' : 'var(--p-primary-600)'}">Cancel</button>
    </div>
</div>